import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  InfoMessageItem,
  InfoMessageItemEntity,
} from '@shared/components/header/info-messages/info-messages.component';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  BankingInformation,
  BankingInformationRequest,
  BusinessPartner,
  BusinessPartnerMasterData,
  CheckBusinessPartnerMasterData,
  MasterDataUpdateRequest,
} from '../data/master-data.data';

@Injectable({
  providedIn: 'root',
})
export class MasterDataService {
  private readonly http = inject(HttpClient);

  getBusinessPartners(): Observable<BusinessPartner[]> {
    return this.http.get<BusinessPartner[]>(
      `${environment.bffClientAccountManagement}/business-partner-management/business-partners-for-masterdata`
    );
  }

  getMasterData(partnerId: string): Observable<BusinessPartnerMasterData> {
    return this.http.get<BusinessPartnerMasterData>(
      `${environment.bffClientAccountManagement}/business-partner-management/business-partners/${partnerId}`
    );
  }

  updateMasterData(partnerId: string, payload: MasterDataUpdateRequest): Observable<Response> {
    return this.http.put<Response>(
      `${environment.bffClientAccountManagement}/business-partner-management/business-partners/${partnerId}`,
      payload
    );
  }

  requestBankingInfoChange(
    partnerId: string,
    payload: BankingInformationRequest
  ): Observable<Response> {
    return this.http.post<Response>(
      `${environment.bffClientAccountManagement}/business-partner-management/business-partners/${partnerId}/banking-info`,
      payload
    );
  }

  checkMasterDataComplete(): Observable<InfoMessageItem> {
    return this.http
      .get<CheckBusinessPartnerMasterData>(
        `${environment.bffClientAccountManagement}/business-partner-management/business-partners-for-masterdata/check`
      )
      .pipe(
        map(response => {
          let messageItem: InfoMessageItem;
          if (!response.invalidBusinessPartners.length) {
            return null;
          } else if (response.numberOfBusinessPartners === 1) {
            messageItem = {
              id: Date.now().toString(),
              link: '/businessPartner/masterData',
              linkTextKey: 'BP_MASTER_DATA.POPUP_BUTTON_TEXT',
              messageKey: 'BP_MASTER_DATA.POPUP_MESSAGE_1',
            } as InfoMessageItem;
          } else {
            messageItem = {
              id: Date.now().toString(),
              link: '/businessPartner/masterData',
              linkTextKey: 'BP_MASTER_DATA.POPUP_BUTTON_TEXT',
              messageKey: 'BP_MASTER_DATA.POPUP_MESSAGE_2',
              entities: response.invalidBusinessPartners.map(partner => {
                return partner as InfoMessageItemEntity;
              }),
            } as InfoMessageItem;
          }

          return messageItem;
        })
      );
  }

  checkBankingInformation(partnerId: string, payload: BankingInformation): Observable<void> {
    return this.http.post<void>(
      `${environment.bffClientAccountManagement}/business-partner-management/business-partners/${partnerId}/banking-info-check`,
      payload
    );
  }
}
